import { createContext, useEffect, useState, useContext } from "react";
import AuthenApi from "@/api/authen";
import { usePathname, useRouter } from "next/navigation";
import { isPermission } from "@/utils";
import { set } from "date-fns";

const initData = {
  user: {},
};

const UserContext = createContext(initData);


export function UserProvide(props) {
  const [user, setUser] = useState();
  const router = useRouter()
  const pathname = usePathname();
  const getUserInfo = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token && pathname.includes("/candidates-dashboard")) {
        router.push("/");
        return;
      }
      if (!token && pathname === "/") {
        setUser(null);
        return;
      }
      const res = await AuthenApi.getProfile(token);
      if (!res.resultData) {
        setUser(null);
        router.push("/");
        return;
      }
      setUser(res.resultData);
    } catch (error) {
      if (pathname.includes("/candidates-dashboard")) {
        router.push("/");
        setUser(null);
      }
    }
  };

  useEffect(() => {
    getUserInfo()
  }, [])

  useEffect(() => {
    if (window && window.Tawk_API) {
      window.Tawk_API.onLoad = function () {
        window.Tawk_API.setAttributes(
          {
            userId: user?.id,
            name: user?.fullName,
            email: user?.email,
            phone: user?.phone,
          },
          function (error) {}
        );
      };
    }
  }, [user]);


  const onRefresh = () => {
    getUserInfo();
  };

  return (
    <UserContext.Provider value={{ user, onRefresh: onRefresh }} {...props} />
  );
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("Error!");
  }
  return context;
}
